var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06752 5.5L5 0.781025L8.93248 5.5H1.06752Z",
    stroke: "var(--sort-up-color, currentColor)",
    fill: "var(--sort-up-fill, none)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93248 8.5L5 13.219L1.06752 8.5L8.93248 8.5Z",
    stroke: "var(--sort-down-color, currentColor)",
    fill: "var(--sort-down-fill, none)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.b8db1bd8f2db595a4454615c5c54ae63.svg";
export { ForwardRef as ReactComponent };